import UserInfo from "../common/UserInfo";
import { useState } from "react";
import { User } from "../common/types";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Button } from "react-bootstrap";
import { useCreateUserMutation } from "@generated";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { formatUser } from "../common/api/helpers";
import { handleAlert } from "@utils/helperFunctions";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";
import { useNavigate } from "react-router";

const Create = ({ account, teams, roles, editor }) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const url = window.location.href;
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [showSuccessAlert, setShowSuccessAlert] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showFailAlert, setShowFailAlert] = useState<boolean>(false);
  const [updating, setUpdating] = useState<boolean>(false);
  const [user, setUser] = useState<User>({
    id: 0,
    name: "",
    title: "",
    email: "",
    phone: "",
    teams: [],
    roles: [],
    userType: "licensed",
    sales: false,
    presales: false,
    startPage: "Home",
  });
  const [create] = useCreateUserMutation();

  const handleSave = (addAnother) => {
    const data = formatUser(user, account?.data?.attributes?.["account-id"]);
    create({ slug: accountSlug, body: { data } })
      .unwrap()
      .then((res) => {
        const id = res?.data?.id;
        setSuccessMessage("User created");
        setShowSuccessAlert(true);
        if (addAnother) {
          setUser({
            id: 0,
            name: "",
            email: "",
            title: "",
            phone: "",
            teams: [],
            roles: [],
            userType: "licensed",
            sales: false,
            presales: false,
            startPage: "Home",
          });
        } else if (id) {
          const userId = url?.split("/")?.slice(-4, -3)?.[0];
          navigate(`/users/${userId}/edit/users/edit/${id}`);
        }
      })
      .catch((err) => {
        const error = err?.data?.errors?.[0];
        setErrorMessage(
          err?.data?.errors?.[0]?.meta?.exception ||
            error?.detail ||
            "Something went wrong saving this user"
        );
        setShowFailAlert(true);
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  return (
    <div className="userForm">
      {handleAlert(
        showSuccessAlert,
        successMessage,
        setShowSuccessAlert,
        "success",
        ToastAlert
      )}
      {handleAlert(
        showFailAlert,
        errorMessage,
        setShowFailAlert,
        "warning",
        ToastAlert
      )}
      <div className="headerContainer">
        <div className="headerText">
          <Button
            className="ssButtonBgWhite"
            onClick={() =>
              window.location.replace(url.split("/").slice(0, -1).join("/"))
            }
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
          Add a User
        </div>
        <div className="actionBtns">
          <Button
            className="ssButtonBgWhite"
            onClick={() => {
              if (!user.roles?.length) {
                setErrorMessage("Please select a user role");
                setShowFailAlert(true);
                return;
              }
              setUpdating(true);
              handleSave(true);
            }}
            style={{ marginRight: "10px" }}
            disabled={!user.name || !user.email}
          >
            Save & Add Another
          </Button>
          <Button
            className="squareGreenButton"
            onClick={() => {
              if (!user.roles?.length) {
                setErrorMessage("Please select a user role");
                setShowFailAlert(true);
                return;
              }
              setUpdating(true);
              handleSave(false);
            }}
            disabled={!user.name || !user.email}
          >
            Save
          </Button>
        </div>
      </div>
      {updating ? (
        <ScopeStackSpinner />
      ) : (
        <UserInfo
          user={user}
          setUser={setUser}
          teams={teams}
          roles={roles}
          account={account}
          editor={editor}
        />
      )}
    </div>
  );
};

export default Create;
